import "../scss/main.scss";
import PageDefault from "./pages/PageDefault";
import Navigation from "./components/Navigation";
import { pxToRem } from "./inc/helpers";

document.addEventListener("DOMContentLoaded", (e) => {
  const main = new Main();
  main.init();
});

class Main {
  constructor() {
    this.template = window["appData"].template;
    this.data = window["appData"].data ?? [];
  }

  init() {
    this.initStyleProps();
    this.initSiteHeader();
    this.initTemplate();
    this.initBtnScrollDown();
  }

  initStyleProps() {
    const initialH = window.innerHeight;
    document.documentElement.style.setProperty("--initial-h", `${initialH}px`);
  }

  initSiteHeader() {
    const onBtnClick = (bool) => {
      if (bool) {
        if (!document.body.classList.contains("overflow-hidden"))
          document.body.classList.add("overflow-hidden");

        return;
      }

      document.body.classList.remove("overflow-hidden");
    };
    const container = document.querySelector(".js-site-header");
    const btn = container?.querySelector(".js-menu-toggle");
    const nav = container?.querySelector(".js-site-navigation");
    const navigation = new Navigation({ container, btn, nav, onBtnClick });
    navigation.init();

    let resizing;
    const breakpoint = `(max-width: ${pxToRem(991)}rem)`;
    document.documentElement.style.setProperty(
      "--nav-h",
      `${container.offsetHeight}px`,
    );
    window.addEventListener("resize", (e) => {
      clearTimeout(resizing);
      resizing = setTimeout(() => {
        document.documentElement.style.setProperty(
          "--nav-h",
          `${container.offsetHeight}px`,
        );
        document.body.classList.remove("overflow-hidden");
        navigation.open = !window.matchMedia(breakpoint).matches;
      }, 250);
    });
  }

  initBtnScrollDown() {
    const btn = document.querySelector(".js-btn-scroll-down");
    const container = btn?.closest(".main-header");
    btn?.addEventListener("click", (e) => {
      window.scrollBy({
        top: container?.offsetHeight - window.scrollY,
        left: 0,
        behavior: "smooth",
      });
    });
  }

  initTemplate() {
    const page = new PageDefault(this.data);
    page.init();
  }
}
